import AdsBanner from "../Ads";
import { DESKTOP_MEDIA_QUERY, DESKTOP_PlUS_MEDIA_QUERY } from "../../constants/breakpoints";
import useMediaQuery from "@/utils/useMediaQuery";
import { useMemo } from "react";
import { Wrapper } from "./AdsDesktopPanel.components";
import { CONFIG } from "@/config";

const AdsDesktopPanel = () => {
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY);
  const isDesktopPlus = useMediaQuery(DESKTOP_PlUS_MEDIA_QUERY);

  const bannerWidth = useMemo(() => {
    const bannerWidthMap = {
      desktopPlus: 400,
      default: 308,
    };

    return isDesktopPlus ? bannerWidthMap.desktopPlus : bannerWidthMap.default;
  }, [isDesktopPlus]);

  const bannerHeight = 280;

  return (
    isDesktop && (
      <Wrapper>
        <AdsBanner display="block" dataAdSlot={CONFIG.DESKTOP_ADS_SLOT_1} width={bannerWidth} height={bannerHeight} />

        <AdsBanner display="block" dataAdSlot={CONFIG.DESKTOP_ADS_SLOT_2} width={bannerWidth} height={bannerHeight} />
      </Wrapper>
    )
  );
};

export default AdsDesktopPanel;
